import { MenuItem, styled, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useExportModal } from './hooks';
import { ExportOptions, ImageExportTypes } from './types';

const StyledMenuItem = styled(MenuItem)`
  padding: 5px 10px;
`;

interface ImageExportMenuProps {
  openExportDialog: (type: ImageExportTypes) => void;
  showExportOptions: Record<ExportOptions, boolean>;
}

const ImageExportMenu = (props: ImageExportMenuProps) => {
  const { t } = useTranslation();
  const { openExportDialog, showExportOptions } = props;
  return (
    <>
      {showExportOptions[ExportOptions.PDF_IMAGE] ? (
        <StyledMenuItem onClick={() => openExportDialog(ImageExportTypes.PDF)}>
          <Typography variant="body2">
            {t('common:dashboardSideBar.exportPdf')}
          </Typography>
        </StyledMenuItem>
      ) : null}
      {showExportOptions[ExportOptions.PNG_IMAGE] ? (
        <StyledMenuItem onClick={() => openExportDialog(ImageExportTypes.PNG)}>
          <Typography variant="body2">
            {t('common:dashboardSideBar.exportPng')}
          </Typography>
        </StyledMenuItem>
      ) : null}
    </>
  );
};

interface ExportMenuProps {
  menuOpen: boolean;
  showExportOptions: Record<ExportOptions, boolean>;
}

export const ExportMenu = (props: ExportMenuProps) => {
  const { showExportOptions, menuOpen } = props;
  const { handleOpen } = useExportModal();
  return (
    <>
      {menuOpen ? (
        <ExportMenuItems
          showExportOptions={showExportOptions}
          handleOpened={handleOpen}
        />
      ) : null}
    </>
  );
};

interface ExportMenuItemsProps {
  handleOpened: (type: ImageExportTypes) => void;
  showExportOptions: Record<ExportOptions, boolean>;
}

export const ExportMenuItems = (props: ExportMenuItemsProps) => {
  const { showExportOptions, handleOpened } = props;

  const hasExportOptionEnabled = Object.values(showExportOptions).some(
    (o) => o === true
  );

  return (
    <>
      {hasExportOptionEnabled && (
        <ImageExportMenu
          openExportDialog={handleOpened}
          showExportOptions={showExportOptions}
        />
      )}
    </>
  );
};
